import { AxiosResponse } from 'axios';

import RestAPI from 'components/Common/restApi';
import { UpdateRecordingProps } from 'components/Voice/Api';
import { EnvironmentVariables, ServicePro } from 'components/Voice/Redundancy/types';
import { VoiceToken } from 'components/Voice/types';

declare global {
  interface Window {
    VOICE_REDUNDANCY_URL: string;
  }
}

type Response<T> = Promise<AxiosResponse<T>>;

export default class RedundancyApi {
  static credentialOptions: { withCredentials: boolean } = { withCredentials: true };

  static authenticate(): Response<never> {
    return RestAPI.get(`${window.VOICE_REDUNDANCY_URL}/auth/housecall_url`).then((response: AxiosResponse) =>
      RestAPI.get(response.data.url, this.credentialOptions)
    );
  }

  static fetchPro(): Response<ServicePro> {
    return RestAPI.get(`${window.VOICE_REDUNDANCY_URL}/pro`, this.credentialOptions);
  }

  static token(): Response<VoiceToken> {
    return RestAPI.post(`${window.VOICE_REDUNDANCY_URL}/credentials/token`, this.credentialOptions);
  }

  static fetchEnvironmentVariables(): Response<EnvironmentVariables> {
    return RestAPI.get(
      process.env.VOICE_REDUNDANCY_URL
        ? `${process.env.VOICE_REDUNDANCY_URL}/environment_variables.json`
        : 'http://localhost:3500/environment_variables.json'
    );
  }

  static updateRecording({ callSid, status, displayDirection }: UpdateRecordingProps) {
    return RestAPI.updateWithFormData(
      `${window.VOICE_REDUNDANCY_URL}/recordings`,
      {
        call_sid: callSid,
        status,
        display_direction: displayDirection,
      },
      this.credentialOptions
    );
  }
}
